import { type ReactElement, useCallback, useEffect } from 'react';
import { Button } from '@direct-frontend/components';
import { showError } from '../../../lib/toast';
import { ErrorBlankTears } from '../../ErrorBlank';

/** Единый заголовок острова при сбое загрузки данных в гриде. */
export const GRID_FETCH_ERROR_TITLE = 'Не удалось загрузить данные';

export type UseGridFetchErrorParams = {
    isError: boolean;
    error: unknown;
    refetch: () => void;
};

export type UseGridFetchErrorResult = {
    isErrorState: boolean;
    renderErrorIslandContent: () => ReactElement;
};

/**
 * Тост при ошибке загрузки и остров {@link ErrorBlankTears} с кнопкой «Повторить».
 *
 * @kind helper
 * @returns {UseGridFetchErrorResult}
 */
export function useGridFetchError({ isError, error, refetch }: UseGridFetchErrorParams): UseGridFetchErrorResult {
    useEffect(() => {
        if (isError) {
            showError({}, error);
        }
    }, [isError, error]);

    const renderErrorIslandContent = useCallback(
        () => (
            <ErrorBlankTears
                data-testid="GridFetchError"
                title={GRID_FETCH_ERROR_TITLE}
                subtitle={error instanceof Error ? error.message : undefined}
                controls={
                    <Button size="m" color="normal" onClick={() => refetch()} data-testid="GridFetchError.Retry">
                        Повторить
                    </Button>
                }
            />
        ),
        [error, refetch]
    );

    return {
        isErrorState: isError,
        renderErrorIslandContent,
    };
}
